import allfivecareplanservices from "../../services/allfivecareplanservices";

export const getPlans = async () => {
    const res = await allfivecareplanservices.getPlans();
    return res;
};
